import React, { useEffect, useState } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import fraudAlert from "../../Images/fraud-alert.jpg";
import "./FraudAlert.css";

function FraudAlert() {
    const ClosePopup = <FontAwesomeIcon icon={faTimes} />
const [fraudPopup, setfraudPopup] = useState(true);
    const fraudPopupClose = () => {
      setfraudPopup(false);
    };

    return(
        <> 
        <Container>
            <Modal
            show={fraudPopup}
            onHide={fraudPopupClose}
            backdrop="static"
            keyboard={false}
            className="fraudPopup-popup"
            >
            <Modal.Body>
                <div className="fraudPopup-popupbody">
                    <img src={fraudAlert}></img>
                    <span className="closeBtn" onClick={fraudPopupClose}> {ClosePopup} </span>
                </div>
            </Modal.Body>
            </Modal>
        </Container>
                                          
        </>
    )
}

export default FraudAlert;